import { render, staticRenderFns } from "./StepsOptionsLegs.vue?vue&type=template&id=ae96234a"
import script from "./StepsOptionsLegs.vue?vue&type=script&lang=js"
export * from "./StepsOptionsLegs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports